module.exports = __webpack_public_path__ + "img/giveaway-survey.1cd6ad2b.jpg";